import api from './api';

export async function getAssistantCapabilities() {
  const { data } = await api.get('/assistant/capabilities');
  return data;
}

export async function queryAssistant(payload = {}) {
  const { data } = await api.post('/assistant/query', payload);
  return data;
}

export async function queryAssistantPreview(payload = {}) {
  const { data } = await api.post('/assistant/query-preview', payload);
  return data;
}
